<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'

/**
 * shadcn-vue `Card`, drawn as a `ZhPanel` (BG §22): system charcoal ground, hairline border, square
 * corners (the `--radius-*` scale is 0, BG §17.2), and the panel's 1rem / 1.25rem rhythm rather than
 * upstream's roomier 1.5rem. Colour comes from the `--card` pair in theme.css.
 */
const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="card"
    :class="cn('bg-card text-card-foreground flex flex-col gap-4 rounded-xl border py-4 md:gap-5 md:py-5', props.class)"
  >
    <slot />
  </div>
</template>
